import { FormItemProps } from '../templates/FormProps';
import useRoleMemo from '@vindr/utils/hooks/useRoleMemo';
import { Form, TimePicker } from 'antd';

const FormTimePicker = ({
  name,
  label,
  placeholder,
  rules,
  required,
  disabled,
  className,
  noStyle,
  ...props
}: FormItemProps) => {
  const rulesMemo = useRoleMemo({ required, rules, disabled });

  return (
    <Form.Item
      {...{ name, label, placeholder }}
      rules={rulesMemo}
      className={className}
      noStyle={noStyle}
    >
      <TimePicker placeholder={placeholder} className="w-full" disabled={disabled} {...props} />
    </Form.Item>
  );
};

export default FormTimePicker;
